module.exports = __webpack_public_path__ + "img/mic-brokerage.943b7d22.png";